// extracted by mini-css-extract-plugin
export default {"singleMeeting":"style_singleMeeting__A0Did"};